import WebTippsConfigurationTable from './WebTippsConfigurationTable'

export default WebTippsConfigurationTable
